import { VistaprintAuth } from '@vp/auth-react';

const webAuth = new VistaprintAuth.WebAuth();

export const getAuthHeader = () => ({
  headers: {
    Authorization: webAuth.getAuthorizationHeader(),
    'Content-Type': 'application/json',
  },
});
